import {DrawerProps} from '@mantine/core';

import {FormDrawer} from './FormDrawer';
import {useBillableUnit} from '../hooks/useBillableUnit';
import {BillableUnit} from '../types';

export const EditFormDrawer = ({record, ...props}: DrawerProps & { record: BillableUnit }) => {
    const {updateRecord} = useBillableUnit(record.id);

    return (
        <FormDrawer
            record={record}
            handleSubmit={updateRecord}
            {...props}
        />
    );
};
